import { render, staticRenderFns } from "./planContributeInfo.vue?vue&type=template&id=82574950&scoped=true&"
import script from "./planContributeInfo.vue?vue&type=script&lang=js&"
export * from "./planContributeInfo.vue?vue&type=script&lang=js&"
import style0 from "./planContributeInfo.vue?vue&type=style&index=0&id=82574950&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82574950",
  null
  
)

export default component.exports